import React from "react";
import {withTranslate} from "react-redux-multilingual"
import {Link} from "react-router-dom";
import ProgressiveImage from "react-progressive-image-loading";
import {slice_text} from "../../helpers/magic";
import Rating from "react-rating";
import DoctorsPage from "../../views/doctors/Doctor";

const DoctorCard = ({translate, doctor, handelBookingFromMobile, language}) => (

    <section className="doctor-card shadow-4d rounded-corners">
        <div className="headline">
            <div className="rating-area">
                         <span hidden={doctor.sponsored === 0 || !doctor.sponsored}
                               className="doctor-sponsored pull-left bolder">{translate('sponsored')}</span>
                <div className="pull-right text-center">
                    <Rating
                        direction={language === 'ar' ? "rtl" : "ltr"}
                        initialRating={doctor.rate}
                        readonly
                        emptySymbol="fa fa-star-o font-20 empty-star"
                        fullSymbol="fa fa-star font-20 full-star"
                    />
                    <p>{doctor.reviews + " " + translate('reviews')}</p>
                </div>
            </div>
            <div className="doctor-full-image">
                        <span hidden={doctor.is_premium === 0 || !doctor.is_premium}><img alt="premium"
                                                                                          src="../../images/premium.png"/></span>
                <div className="doctor-image avatar">
                    <ProgressiveImage
                        preview="/images/doctor-image-placeholder.png"
                        src={doctor.image}
                        render={(src, style) => <img alt={doctor.name} src={src} style={style}/>}
                    />
                    {
                        doctor.hospital ?
                            <a href={"/doctor/" + doctor.hospital.unique_id + "/hospital"}>
                                <div className="hospital-area">
                                    <ProgressiveImage
                                        preview="/images/doctor-image-placeholder.png"
                                        src={doctor.hospital.image}
                                        render={(src, style) => <img alt={doctor.hospital.name} src={src}
                                                                     style={style}/>}
                                    />
                                    <p className="trimmed-p">{doctor.hospital.name}</p>
                                </div>
                            </a> : null
                    }

                </div>
            </div>

            <div className="account">
                <span><i className="fas fa-star rec-star mr-2" hidden={doctor.is_recommended === 0}></i></span>
                <Link to={"/doctor/" + doctor.unique_id}> <span
                    className="doctor-name capitalized trim">{doctor.name}</span></Link>
                {/*
                        <p className="doctor-title bolder loon2">{doctor.speciality ? doctor.speciality : "--"}</p>*/}
                <p className="doctor-title font-17">{(doctor.title && doctor.title !== "" && doctor.title !== null) ? slice_text(doctor.title, 20) : "__"}</p>
                <p className="doctor-followers  capitalized">{translate("recommended_by") + " "} <span
                    className="bolder app-color">{doctor.my_recommends_count}</span> {" " + translate("user")}
                </p>
                {/*<p className="doctor-fees">{translate("min_fees") + " " + doctor.min_fees + " " + translate("currency")}</p>*/}
            </div>
        </div>
        <hr style={{marginTop: ".5rem", marginBottom: ".5rem"}}/>
        <div className="show-more text-center">
            <div>
                <p className="title">{translate("fees")}</p>
                <p className="doctor-fees">
                              <span className="inline-block">
                                                        <img className="icon" src="/images/floos.png" alt=""
                                                             style={{width: "75%"}}/>
                                                    </span>
                    {doctor.min_fees + " " + translate("currency")}
                </p>
            </div>
            <div className="right-hr"></div>
            <div hidden={doctor.is_premium === 0 || !doctor.is_premium}>
                <p className="title">{translate("premium_fees")}</p>
                <p className="doctor-fees">
                              <span className="inline-block">
                                                        <img className="icon" src="/images/floos.png" alt=""
                                                             style={{width: "75%"}}/>
                                                    </span>
                    {doctor.min_premium_fees + " " + translate("currency")}
                </p>
            </div>
            <div className="right-hr" hidden={doctor.is_premium === 0 || !doctor.is_premium}></div>
            <Link to={"/doctor/" + doctor.unique_id} className="card-btn-book">
                <button className="btn doctor-book shadow-4d"
                        onClick={() => handelBookingFromMobile()}>{translate("book")}</button>
            </Link>
        </div>
    </section>
);


export default withTranslate(DoctorCard);


/*

<a href="https://rklinic-admin.com/user-activate/RK_ACC_1099?token=$2y$10$E6fpQyoAzJOKAbtPNdoJ7et3CVHhUUIhBYrUf0sAsW8coM.5ofKO2" target="_blank" data-saferedirecturl="https://www.google.com/url?q=https://rklinic-admin.com/user-activate/RK_ACC_1099?token%3D$2y$10$E6fpQyoAzJOKAbtPNdoJ7et3CVHhUUIhBYrUf0sAsW8coM.5ofKO2&amp;source=gmail&amp;ust=1545915521139000&amp;usg=AFQjCNFkk4PkCfRJCRsHIFGe-8jt-gUnzA" data-saferedirectreason="2">here</a>
<a href="https://rklinic-admin.com/user-activate/RK_ACC_1099?token=$2y$10$E6fpQyoAzJOKAbtPNdoJ7et3CVHhUUIhBYrUf0sAsW8coM.5ofKO2" target="_blank" data-saferedirecturl="https://www.google.com/url?q=https://rklinic-admin.com/user-activate/RK_ACC_1099?token%3D$2y$10$E6fpQyoAzJOKAbtPNdoJ7et3CVHhUUIhBYrUf0sAsW8coM.5ofKO2&amp;source=gmail&amp;ust=1545915521139000&amp;usg=AFQjCNFkk4PkCfRJCRsHIFGe-8jt-gUnzA" data-saferedirectreason="2">here</a>*/
